import React, { FC } from 'react'
import { View } from 'react-native'

import formatDecimals from '@ambire-common/utils/formatDecimals/formatDecimals'
import { createGlobalTooltipDataSet } from '@common/components/GlobalTooltip'
import Text from '@common/components/Text'
import useTheme from '@common/hooks/useTheme'
import { NEUTRAL_BACKGROUND_HOVERED } from '@common/modules/dashboard/screens/styles'
import spacings from '@common/styles/spacings'
import { THEME_TYPES } from '@common/styles/themeConfig'
import common from '@common/styles/utils/common'
import flexbox from '@common/styles/utils/flexbox'

export interface RailgunMissingPoiUsdPillProps {
  usdTotal: number
}

const MISSING_POI_TOOLTIP = 'This amount will be automatically resolved shortly'

const RailgunMissingPoiUsdPill: FC<RailgunMissingPoiUsdPillProps> = ({ usdTotal }) => {
  const { theme, themeType } = useTheme()

  if (usdTotal <= 0) return null

  const labelColor =
    themeType === THEME_TYPES.DARK ? theme.primaryBackgroundInverted : theme.primaryBackground

  return (
    <View
      style={[
        flexbox.directionRow,
        flexbox.alignCenter,
        spacings.phTy,
        spacings.pvMi,
        common.borderRadiusPrimary,
        {
          backgroundColor: NEUTRAL_BACKGROUND_HOVERED,
          minHeight: 28
        }
      ]}
      dataSet={createGlobalTooltipDataSet({
        id: 'overview-missing-poi-usd',
        content: MISSING_POI_TOOLTIP
      })}
    >
      <Text
        fontSize={12}
        weight="number_medium"
        style={{ lineHeight: 14 }}
        color={labelColor}
        testID="missing-poi-usd-pill"
      >
        {`Incoming ${formatDecimals(usdTotal, 'value')}`}
      </Text>
    </View>
  )
}

export default RailgunMissingPoiUsdPill
